import { create } from 'zustand';

interface ApiKeyRevealState {
  revealedKeys: Set<number>;
  toggleReveal: (id: number) => void;
  reset: () => void;
}

export const useApiKeyRevealStore = create<ApiKeyRevealState>(set => ({
  revealedKeys: new Set(),
  toggleReveal: (id: number) =>
    set(state => {
      const next = new Set(state.revealedKeys);
      if (next.has(id)) {
        next.delete(id);
      } else next.add(id);
      return { revealedKeys: next };
    }),
  reset: () => set({ revealedKeys: new Set() }),
}));
